import { render } from "./App.vue?vue&type=template&id=50db1f3a"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=50db1f3a&lang=scss"

import exportComponent from "/Users/umar/Desktop/umi-portfolio-2021/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__